export const SPLINE_PATH = '/models/virvelle.draco.glb'
export const PRIMITIVES_PATH = '/models/hero.glb'
export const NOISE_PATH = '/assets/textures/perlin-datatexture.png' // '/assets/textures/perlin-datatexture.png'

export const DRACO_DECODERS = 'https://www.gstatic.com/draco/v1/decoders/'

export const MAX_PIXEL_COUNT = 2560 * 1440
